// 系统设置
export default [
  {
    path: '/systemSettings/organizationalManagement',
    component: resolve => require(['@/pages/systemSettings/organizationalManagement.vue'], resolve),
    name: 'organizationalManagement',
    meta: {
      title: '组织管理'
    }
  },
  {
    path: '/systemSettings/personnelManagement',
    component: resolve => require(['@/pages/systemSettings/personnelManagement.vue'], resolve),
    name: 'personnelManagement',
    meta: {
      title: '人员管理'
    }
  },
  {
    path: '/systemSettings/postManagement',
    component: resolve => require(['@/pages/systemSettings/postManagement.vue'], resolve),
    name: 'postManagement',
    meta: {
      title: '岗位管理'
    }
  }
]


// WEBPACK FOOTER //
// ./src/router/modules/systemSettings.js